import { fetchV1 } from "../lib/requester/v1";

export function completeFunderOnboarding(data) {
  console.log('🚀 Starting funder onboarding API call with data:', data);
  
  return fetchV1("/funder-onboarding/complete", { 
    method: "POST", 
    data 
  }).then(result => {
    console.log('✅ Funder onboarding API call successful:', result);
    return result;
  }).catch(error => {
    console.error('❌ Funder onboarding API call failed:', error);
    throw error;
  });
}

export function resolveFunderOnboardingToken(token) {
  return fetchV1("/funder-onboarding/resolve", { 
    method: "POST", 
    data: { token } 
  });
}
